import React, { useRef, useEffect, useState } from 'react'
import { CircularProgress, Box } from '@mui/material'
import hapanaAnimation from '../../../../../styles/assets/lotties/loading.json'

export interface LoaderProps {
  size?: number
  speed?: number
  label?: string
  className?: string
  style?: React.CSSProperties
  testId?: string
  context?: string
}

export const HapanaLoader: React.FC<LoaderProps> = ({ size = 40, speed = 1.0 }) => {
  const playerRef = useRef<any>(null)
  const [Player, setPlayer] = useState<any>(null)

  useEffect(() => {
    let cancelled = false
    const loadLottie = async () => {
      try {
        const module = await import('@lottiefiles/react-lottie-player')
        if (!cancelled) {
          setPlayer(() => module.Player)
        }
      } catch (error) {
        console.warn('HapanaLoader: Lottie Player not available, using fallback')
      }
    }
    loadLottie()

    return () => {
      cancelled = true
      if (playerRef.current) {
        try {
          playerRef.current.stop?.()
        } catch (error) {}
      }
    }
  }, [])

  const loaderStyle = {
    height: size * 2,
    width: size * 2,
  }

  if (Player) {
    return (
      <Player
        ref={playerRef}
        autoplay
        loop
        src={hapanaAnimation}
        style={loaderStyle}
        speed={speed}
      />
    )
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CircularProgress size={size * 2} />
    </Box>
  )
}
